import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import { SwitchButtonValue, ZoneCreationProperties } from '../types/zoneMapType';

interface StoreOrModeChangeConfirmationModalProps {
  newStore: string | undefined;
  switchButtonValue: string | undefined;
  setStore: (value: string) => void;
  setNewStore: (value: string | undefined) => void;
  setZoneCreationProperties: (value: Map<number, ZoneCreationProperties>) => void;
  initialZoneCreationPropertiesMap: Map<number, ZoneCreationProperties>;
  setStoreOrModeChangeConfirmationModal: (value: { open: boolean; showStoreWarning: boolean }) => void;
  storeChangeConfirmationModal: {
    open: boolean;
    showStoreWarning: boolean;
  };
  onConfirmSwitchButton: () => void;
}

const StoreOrModeChangeConfirmationModal = (props: StoreOrModeChangeConfirmationModalProps) => {
  const {
    newStore,
    switchButtonValue,
    setStore,
    setNewStore,
    setStoreOrModeChangeConfirmationModal,
    storeChangeConfirmationModal,
    setZoneCreationProperties,
    initialZoneCreationPropertiesMap,
    onConfirmSwitchButton,
  } = props;

  const onConfirmStoreChange = () => {
    setStore(newStore!);
    setNewStore(undefined);
    setStoreOrModeChangeConfirmationModal({
      open: false,
      showStoreWarning: false,
    });
    // when user switches to createZone, set props to initial
    if (switchButtonValue === SwitchButtonValue.CreateZoneMap) {
      setZoneCreationProperties(initialZoneCreationPropertiesMap);
    }
  };

  const onClose = () =>
    setStoreOrModeChangeConfirmationModal({
      open: false,
      showStoreWarning: false,
    });
  return (
    <Modal
      title="Store/Mode Change Confirmation"
      open={storeChangeConfirmationModal.open}
      onClose={onClose}
      scrollContainer="viewport"
      closeLabel="Close"
      aria-describedby="modal-description"
    >
      <Text id="modal-description">
        {storeChangeConfirmationModal.showStoreWarning
          ? 'You are changing the store. Any changes made will be lost. Do you want to proceed?'
          : 'You are changing the Mode. Any changes made will be lost. Do you want to proceed?'}
      </Text>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="secondary" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={storeChangeConfirmationModal.showStoreWarning ? onConfirmStoreChange : onConfirmSwitchButton}
          >
            Confirm
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default StoreOrModeChangeConfirmationModal;
